import { SimpleGuard } from 'interfaces/guards'
import { getHomesActionCreator, getCarsActionCreator, getCarMakesActionCreator } from 'actions/propertyActions'
import { memberInfoSelector } from 'selectors/globalSelectors'

export const homesGuard: SimpleGuard<{}> = {
  name: 'Homes',
  checker: (state) => {
    const member = memberInfoSelector(state)
    return !member || state.data.property.homes !== null || member.onboarding_step === 'property'
  },
  loader: (dispatch) => dispatch(getHomesActionCreator()),
}

export const carsGuard: SimpleGuard<{}> = {
  name: 'Cars',
  checker: (state) => {
    const member = memberInfoSelector(state)
    return !member || state.data.property.cars !== null || member.onboarding_step === 'property'
  },
  loader: (dispatch) => dispatch(getCarsActionCreator()),
}

export const carsMakesGuard: SimpleGuard<{}> = {
  name: 'CarsMakes',
  checker: (state) => {
    const member = memberInfoSelector(state)
    return !member || state.data.property.carMakes.length !== 0
  },
  loader: (dispatch) => dispatch(getCarMakesActionCreator()),
}
